import * as wasm from "./ttml_processor_bg.wasm";
export * from "./ttml_processor_bg.js";
import { __wbg_set_wasm } from "./ttml_processor_bg.js";
__wbg_set_wasm(wasm);
wasm.__wbindgen_start();
